export const NODE_ENV = process.env.REACT_APP_NODE_ENV || 'dev';
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '/api';
export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
